module.exports = __webpack_public_path__ + "static/media/bitbucket.41cd698f.svg";